// include all the children type definitions into this "directory" level namespace
// order is important for dependent types

// these are common between the API server and this app
export * from "@/app/types/common"
export * from "@/app/types/interval"
export * from "@/app/types/metric"

// these are specific to this API server
export * from "@/app/types/api_ai"
export * from "@/app/types/api_categories_list"
export * from "@/app/types/api_custom_list"
export * from "@/app/types/api_filters"
export * from "@/app/types/api_firm"
export * from "@/app/types/api_firm_interval"
export * from "@/app/types/api_firms_list"
export * from "@/app/types/api_flow_monitor"
export * from "@/app/types/api_fund"
export * from "@/app/types/api_fund_interval"
export * from "@/app/types/api_funds_list"
export * from "@/app/types/api_meta_terms"
export * from "@/app/types/api_metrics"
export * from "@/app/types/api_notes"
export * from "@/app/types/api_oppfinder"
export * from "@/app/types/api_pulses_list"
export * from "@/app/types/api_user"
export * from "@/app/types/api_viz"

// these are specific to this app
export * from "@/app/types/calculation"
export * from "@/app/types/chart"
export * from "@/app/types/chart_definitions"
export * from "@/app/types/comparison_new"
export * from "@/app/types/entity"
export * from "@/app/types/event_tracker"
export * from "@/app/types/flag_definitions"
export * from "@/app/types/group"
export * from "@/app/types/lookup"
export * from "@/app/types/notifier"

// graph specific
export * from "@/app/types/chart_data"
export * from "@/app/types/formatters"

export const IS_SERVER = (): boolean => typeof window === "undefined" // server
export const IS_BROWSER = (): boolean => typeof window !== "undefined" // client
